import { t } from "i18next";
import { z } from "zod";

export const RecorderFormSchema = z.object({
  title: z.string().optional(),
  template: z.string().min(1, t("schemas.newVisit.template.min")),
  customTemplatePublicId: z.uuidv4().toLowerCase().nullable(),
  templateName: z.string(),
  style: z.string().min(1, t("schemas.newVisit.style.min")),
  format: z.string().min(1, t("schemas.newVisit.format.min")),
  examination: z.string().min(1, t("schemas.newVisit.examination.min")),
});

export type RecorderFormSchemaType = z.infer<typeof RecorderFormSchema>;
